import type { GuideStructure } from '../../../api/useGenerateGuideStructure';
import { Body, Stack, SubHeading } from '@workramp/ui';
import { DocumentLayout } from './DocumentLayout';
import { ModuleContainer, List, ListItem } from './GuideStructureContent.styles';

interface GuideStructureContentProps {
  structure: GuideStructure;
}

export function GuideStructureContent({ structure }: GuideStructureContentProps) {
  return (
    <DocumentLayout
      title={structure.courseTitle}
      description={`Estimated time: ${structure.estimatedTotalTimeMinutes} minutes`}
      ctaLabelShow="Show Structure"
      ctaLabelHide="Hide Structure"
    >
      {structure.modules.map((module) => (
        <ModuleContainer key={`module-${module.moduleTitle}`} size={2}>
          <Stack size={0}>
            <SubHeading level="md">{module.moduleTitle}</SubHeading>
            <Body level="md">{module.objective}</Body>
            <Body level="md">
              <em>Estimated time: {module.estimatedTimeMinutes} minutes</em>
            </Body>
          </Stack>

          <Stack size={0}>
            <SubHeading level="sm">Key Questions</SubHeading>
            <List>
              {module.keyQuestions.map((question) => (
                <ListItem key={`question-${question}`}>{question}</ListItem>
              ))}
            </List>
          </Stack>

          <Stack size={0}>
            <SubHeading level="sm">Suggested Content Formats</SubHeading>
            <List>
              {module.suggestedContentFormats.map((format) => (
                <ListItem key={`format-${format}`}>{format}</ListItem>
              ))}
            </List>
          </Stack>
        </ModuleContainer>
      ))}
    </DocumentLayout>
  );
}
